import React from 'react';

import Button from '../../../Button/Button';
import PopupLayout from '../../PopupLayout/PopupLayout';

import styles from './styles.module.scss';

interface ConfirmPopupProps {
  children: React.ReactNode,
  closeHandler: () => void,
  acceptHandler: () => void,
  isOpen: boolean,
}

const ConfirmPopup = ({
  children,
  closeHandler,
  acceptHandler,
  isOpen,
}: ConfirmPopupProps) => {
  const keyDownHandler = (e: React.KeyboardEvent<any>) => {
    if (e.code === 'Enter') {
      acceptHandler();
    }
  };

  const handleAccept = () => {
    acceptHandler();
    closeHandler();
  };
  return (
    <PopupLayout
      closeHandler={closeHandler}
      isOpen={isOpen}
    >
      <div className={styles.content}>
        {children}
        <div className={styles.buttons}>
          <Button
            variant="success"
            className={styles.button}
            onClick={handleAccept}
            keyDown={keyDownHandler}
            lngKey="button.accept"
          />
          <Button
            variant="error"
            className={styles.button}
            onClick={closeHandler}
            lngKey="button.cancel"
          />
        </div>
      </div>
    </PopupLayout>
  );
};

export default ConfirmPopup;
